import styles from './WebDatenschutzScreen.module.scss'
import { ReactElement } from 'react'
import { DesktopBodyLarge, DesktopHeadlineLarge, DesktopTitleLarge } from '../../Typography'

export const WebDatenschutzScreen = (): ReactElement => {
  return (
    <div className={styles.container}>
      <DesktopHeadlineLarge>Datenschutz</DesktopHeadlineLarge>
      <DesktopTitleLarge>Datenschutzerklärung für eingebettete YouTube-Videos</DesktopTitleLarge>
      <DesktopBodyLarge fontWeight={700}>1. Einleitung</DesktopBodyLarge>
      <DesktopBodyLarge>
        Wir freuen uns über Ihr Interesse an unserer Website. Der Schutz Ihrer persönlichen Daten
        ist uns ein besonderes Anliegen. In dieser Datenschutzerklärung informieren wir Sie darüber,
        welche Daten erhoben werden, wenn Sie unsere Website besuchen und eingebettete
        YouTube-Videos nutzen.
      </DesktopBodyLarge>
      <DesktopBodyLarge fontWeight={700}>2. Einbindung von YouTube-Videos</DesktopBodyLarge>
      <DesktopBodyLarge>
        Unsere Website verwendet eingebettete Videos von YouTube, einem Dienst der Google Ireland
        Limited (Gordon House, Barrow Street, Dublin 4, Irland). Beim Abspielen eines eingebetteten
        Videos werden Daten an YouTube übertragen.
      </DesktopBodyLarge>
      <DesktopBodyLarge fontWeight={700}>3. Welche Daten werden erfasst?</DesktopBodyLarge>
      <DesktopBodyLarge>
        Wenn Sie eine Seite mit einem eingebetteten YouTube-Video aufrufen, kann YouTube unter
        anderem folgende Daten erfassen:
      </DesktopBodyLarge>
      <div className={styles.gaplessBox}>
        <DesktopBodyLarge>{' \u2022 '}Ihre IP-Adresse</DesktopBodyLarge>
        <DesktopBodyLarge>
          {' \u2022 '}Informationen über den verwendeten Browser und das Betriebssystem
        </DesktopBodyLarge>
        <DesktopBodyLarge>
          {' \u2022 '}Besuchte Webseiten und Interaktionen mit dem Video
        </DesktopBodyLarge>
        <DesktopBodyLarge>
          {' \u2022 '}Falls Sie bei YouTube oder Google eingeloggt sind, kann Ihr Nutzungsverhalten
          Ihrem Profil zugeordnet werden.
        </DesktopBodyLarge>
      </div>
      <DesktopBodyLarge fontWeight={700}>4. Rechtsgrundlage der Datenverarbeitung</DesktopBodyLarge>
      <DesktopBodyLarge>
        Die Verarbeitung Ihrer Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO
        (berechtigtes Interesse), da wir ein berechtigtes Interesse an der nutzerfreundlichen
        Einbindung von Videos haben. Falls Sie in die Nutzung von Cookies und Tracking durch YouTube
        einwilligen, erfolgt die Verarbeitung auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO
        (Einwilligung).
      </DesktopBodyLarge>
      <DesktopBodyLarge fontWeight={700}>
        5. Verwendung des erweiterten Datenschutzmodus
      </DesktopBodyLarge>
      <DesktopBodyLarge>
        Soweit möglich, nutzen wir den erweiterten Datenschutzmodus von YouTube. Dadurch werden
        weniger Daten an YouTube übertragen, insbesondere solange Sie das Video nicht aktiv
        abspielen. Sobald Sie das Video starten, können jedoch weitere Daten durch YouTube erfasst
        werden.
      </DesktopBodyLarge>
      <DesktopBodyLarge fontWeight={700}>6. Cookies und Tracking durch YouTube</DesktopBodyLarge>
      <DesktopBodyLarge>
        YouTube kann Cookies und Tracking-Technologien einsetzen. Dies kann dazu führen, dass Ihr
        Nutzungsverhalten analysiert wird. Sie können dies durch entsprechende Einstellungen in
        Ihrem Google-Konto oder durch die Nutzung von Browser-Erweiterungen einschränken.
      </DesktopBodyLarge>
      <DesktopBodyLarge fontWeight={700}>7. Datenweitergabe und Speicherdauer</DesktopBodyLarge>
      <DesktopBodyLarge>
        YouTube kann erhobene Daten an Google-Server in den USA übermitteln. Google verpflichtet
        sich zur Einhaltung der EU-Standardvertragsklauseln zum Schutz personenbezogener Daten. Die
        Speicherdauer hängt von den Richtlinien von Google ab.
      </DesktopBodyLarge>
      <DesktopBodyLarge fontWeight={700}>8. Ihre Rechte</DesktopBodyLarge>
      <DesktopBodyLarge>Sie haben das Recht auf:</DesktopBodyLarge>
      <div className={styles.gaplessBox}>
        <DesktopBodyLarge>
          {' \u2022 '}Auskunft über die gespeicherten Daten (Art. 15 DSGVO)
        </DesktopBodyLarge>
        <DesktopBodyLarge>
          {' \u2022 '}Berichtigung unrichtiger Daten (Art. 16 DSGVO)
        </DesktopBodyLarge>
        <DesktopBodyLarge>{' \u2022 '}Löschung Ihrer Daten (Art. 17 DSGVO)</DesktopBodyLarge>
        <DesktopBodyLarge>
          {' \u2022 '}Einschränkung der Verarbeitung (Art. 18 DSGVO)
        </DesktopBodyLarge>
        <DesktopBodyLarge>
          {' \u2022 '}Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)
        </DesktopBodyLarge>
        <DesktopBodyLarge>{' \u2022 '}Datenübertragbarkeit (Art. 20 DSGVO)</DesktopBodyLarge>
      </div>
      <DesktopBodyLarge>
        Bitte wenden Sie sich an uns, falls Sie Ihre Rechte geltend machen möchten.
      </DesktopBodyLarge>
      <DesktopBodyLarge fontWeight={700}>9. Kontakt</DesktopBodyLarge>
      <DesktopBodyLarge>
        Falls Sie Fragen zum Datenschutz auf unserer Website haben, kontaktieren Sie uns bitte
        unter:
      </DesktopBodyLarge>
      <div className={styles.gaplessBox}>
        <DesktopBodyLarge>FIGHTBACK Wrestling</DesktopBodyLarge>
        <DesktopBodyLarge>c/o German Hurricane Wrestling e. V.</DesktopBodyLarge>
        <DesktopBodyLarge>Goethestraße 13A</DesktopBodyLarge>
        <DesktopBodyLarge>64569 Nauheim</DesktopBodyLarge>
        <DesktopBodyLarge>+49 176 32646683</DesktopBodyLarge>
        <DesktopBodyLarge>office@fightback-wrestling.com</DesktopBodyLarge>
      </div>
      <DesktopBodyLarge fontWeight={700}>
        10. Änderungen dieser Datenschutzerklärung
      </DesktopBodyLarge>
      <DesktopBodyLarge>
        Wir behalten uns das Recht vor, diese Datenschutzerklärung anzupassen, falls sich
        gesetzliche oder technische Änderungen ergeben. Die jeweils aktuelle Version finden Sie auf
        unserer Website.
      </DesktopBodyLarge>
      <DesktopBodyLarge fontStyle={'italic'}>Stand: 29.03.2025</DesktopBodyLarge>
    </div>
  )
}
